import { Switch } from "@/components/ui/switch";
import { TBillingInterval } from "@/types/app";

const config = {
  promotionText: "Save up to 33%",
};

interface BillingToggleProps {
  currentPeriod: TBillingInterval;
  onToggle: (period: "yearly" | "monthly") => void;
  // config: TPricingPageConfig["billingToggle"];
}

export function SwitchPlanInterval({
  currentPeriod,
  onToggle,
}: BillingToggleProps) {
  return (
    <div className="flex items-center gap-10 md:justify-center">
      <div className="flex items-center gap-2">
        {/* Left Label */}
        <span className="font-archivo text-[16px] leading-[27.2px] font-semibold tracking-[0.16px] text-[#323232]">
          Yearly
        </span>

        <div className="rounded-full bg-linear-to-r from-orange-500 via-yellow-400 to-green-500 p-px">
          <div className="rounded-full bg-surface-light px-2 py-1 text-[12px] font-medium whitespace-nowrap">
            {config.promotionText}
          </div>
        </div>

        {/* Switch */}
        <Switch
          checked={currentPeriod === "monthly"}
          onCheckedChange={(checked) =>
            onToggle(checked ? "monthly" : "yearly")
          }
          className="data-[state=checked]:bg-surface-accent data-[state=unchecked]:bg-surface-accent"
        />

        {/* Right Label */}
        <span className="font-archivo text-[16px] leading-[27.2px] font-semibold tracking-[0.16px] text-[#323232]">
          Monthly
        </span>
      </div>
    </div>
  );
}
